module.exports = __webpack_public_path__ + "static/img/1-3.16db645.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/1-3.png
// module id = PWWJ
// module chunks = 0